import { render, staticRenderFns } from "./Epunewpat.vue?vue&type=template&id=b45036aa&scoped=true&"
import script from "./Epunewpat.vue?vue&type=script&lang=js&"
export * from "./Epunewpat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45036aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
installComponents(component, {VStepper,VStepperItems})
